import React from 'react';
import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, x = 0, className = '', duration = 0.8 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, x }}
    whileInView={{ opacity: 1, y: 0, x: 0 }}
    viewport={{ once: true, margin: '-70px' }}
    transition={{ duration, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export default Reveal;
